import { POST } from "../../index";

export const findFaultData = (param) => POST("/v1/Fault/findFaultData", param);
